import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

import variables from "../../../../.././../assets/styles/sass-resources.scss";

const principle: Slide = {
  description:
    "Now we shoot a sequence of N rays and collect the reflection angles ϑ in the histogram (right) with an angular resolution of Δϑ. Check how the form of the distribution of the reflections develops for different number of rays and resolutions.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "N = 1,000, Δϑ = 5°" }, { name: "N = 10,000, Δϑ = 0.5°" }],
        },
      ],
      extraContent: [[], []],
      components: [
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [2, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "video",
                          options: {
                            src: `${config.ASSETS_URL}/03/09/principle/slide-3.mp4`,
                          },
                        },
                        styles: {
                          padding: "2% 21%",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data:
                              "Check how the form of the distribution of the reflections develops when we shoot a sequence of 1,000 rays with a resolution of 5° in intervals of the reflection angle ϑ. If we increase the number of rays and use a resolution of 0.5°, the distribution of the reflections well approximates a circular distribution according to Lamberts law.",
                            scrollbars: false,
                            styles: {
                              color: variables["text-secondary"],
                            },
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                rowsSize: [2, 1],
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "image",
                          options: {
                            src: `${config.ASSETS_URL}/03/09/principle/slide-3.svg`,
                          },
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            data:
                              "The final result from 10,000 random rays is shown with a resolution of 0.5°. The distribution of the reflections well approximates a circular distribution according to Lamberts law.",
                            scrollbars: false,
                            styles: {
                              color: variables["text-secondary"],
                            },
                          },
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
